import {
  FETCH_DATA_EVENTS_REQUEST,
  FETCH_DATA_EVENTS_SUCCESS,
  FETCH_DATA_EVENTS_FAILURE,
} from "../../actions/events/get-event-actions";

const initialState = {
  list: [],
  isLoading: false,
  error: null,
  meta: null,
};

const EventsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_DATA_EVENTS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_DATA_EVENTS_SUCCESS:
      console.log("action.payload.values", action.payload.values);
      return {
        ...state,
        isLoading: false,
        list: action.payload.values,
        meta: action.payload.meta,
      };
    case FETCH_DATA_EVENTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default EventsReducer;
